import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { selectRedirectUrl, selectShouldRedirect, resetShouldRedirect } from './redirectSlice'

/**
 * A helper component to handle redirects from server in case of errors.
 * See the redux store and RedirectSlice.js and rtkQueryErrorLogger in middleware.js in redux-store
 * @returns null
 */
function Redirect() {
  
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const redirectUrl = useSelector(selectRedirectUrl)
  const shouldRedirect = useSelector(selectShouldRedirect)


  useEffect(() => {

    if (redirectUrl && shouldRedirect) {
      navigate(redirectUrl)
      dispatch(resetShouldRedirect())
    }

  }, [redirectUrl, shouldRedirect])

  return null
}

export default Redirect